/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load LinkedIn event listeners
 *
 * https://www.linkedin.com/help/lms/answer/a425606?lang=en-US
 *
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.linkedin?.partner_id && !pmwDataLayer?.pixels?.linkedin?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "LinkedIn")) pmw.load_linkedin_pixel()
	}
})

// view_content event
jQuery(document).on("pmw:pixel:view-item", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: view_content event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
jQuery(document).on("pmw:pixel:add-to-cart", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: add_to_cart event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})


// View order received page event
jQuery(document).on("pmw:pixel:purchase", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "linkedin")) return
		if(pmw.canNotFireLinktrk()) return

		const linkedinData = payload.pixels?.linkedin;
		if (!linkedinData) return;

		window.lintrk("track", linkedinData)
		pmw.console.log("LinkedIn: purchase event sent", linkedinData)

	} catch (e) {
		console.error(e)
	}
})

